export default __webpack_public_path__ + "static/media/comment.3366ea94.svg";